import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'header-menu-item',
	templateUrl: './header-menu-item.component.html',
	styleUrls: ['./header-menu-item.component.scss'],
	preserveWhitespaces: false
})
export class HeaderMenuItemComponent {

	@Input() public path: string = null;
	@Input() public classes: string | string[] = [];
	@Input() public activeClass: string = '';
	@Input() public icon: string = '';
	@Input() public linkEvent: string = null;
	@Input() public disabled: boolean = false;
	@Output() public onMenuItemClick: EventEmitter<any> = new EventEmitter<any>();

}
